import { render, staticRenderFns } from "./SoftFairOffersList.vue?vue&type=template&id=80c330ae&"
import script from "./SoftFairOffersList.vue?vue&type=script&lang=js&"
export * from "./SoftFairOffersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports